import { AlarmTypeGroupDTO } from '@hakimo-ui/hakimo/types';
import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export function useAlarmTypeGroupsByName() {
  const httpClient = useHttpClient();

  return (name: string) => {
    const url = `/v2/orm/alarmtype_groups?name=${name}`;

    return httpClient<Selectable[]>(url, {
      responseModifier: async (response) => {
        const respJson = await response.json();
        const payload = respJson.payload as AlarmTypeGroupDTO;

        if (payload && payload.items) {
          return payload.items.map<Selectable>((item: any) => ({
            id: String(item.alarmtype_group_id),
            name: item.name,
          }));
        }

        return [];
      },
    });
  };
}

export default useAlarmTypeGroupsByName;
